import { render, staticRenderFns } from "./PipelineCRM.vue?vue&type=template&id=93b8eca2&scoped=true"
import script from "./PipelineCRM.vue?vue&type=script&lang=js"
export * from "./PipelineCRM.vue?vue&type=script&lang=js"
import style0 from "./PipelineCRM.vue?vue&type=style&index=0&id=93b8eca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b8eca2",
  null
  
)

export default component.exports